import React, { useState, useEffect } from 'react';
import { Lock } from 'lucide-react';

const STAGING_USERNAME = process.env.REACT_APP_STAGING_USERNAME;
const STAGING_PASSWORD = process.env.REACT_APP_STAGING_PASSWORD;

const PasswordGate = ({ children }) => {
  const [authenticated, setAuthenticated] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!STAGING_PASSWORD) {
      setAuthenticated(true);
      return;
    }
    if (sessionStorage.getItem('myl_auth') === 'true') {
      setAuthenticated(true);
    }
  }, []);

  if (authenticated) return children;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (username === STAGING_USERNAME && password === STAGING_PASSWORD) {
      sessionStorage.setItem('myl_auth', 'true');
      setAuthenticated(true);
    } else {
      setError(true);
      setTimeout(() => setError(false), 2000);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#00594C] to-[#003d35] flex items-center justify-center px-4">
      <div className="bg-white rounded-2xl p-8 shadow-xl max-w-sm w-full">
        <div className="text-center mb-6">
          <div className="w-14 h-14 bg-[#99DF63]/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <Lock className="w-7 h-7 text-[#00594C]" />
          </div>
          <h1 className="text-xl font-bold text-[#00594C]">Staging Preview</h1>
          <p className="text-gray-500 text-sm mt-1">Enter credentials to continue</p>
        </div>
        <form onSubmit={handleSubmit} data-no-track className="space-y-4">
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Username"
            autoFocus
            className={`w-full px-4 py-3 border rounded-lg outline-none transition-colors ${
              error
                ? 'border-red-400 bg-red-50'
                : 'border-gray-300 focus:ring-2 focus:ring-[#99DF63] focus:border-[#00594C]'
            }`}
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            className={`w-full px-4 py-3 border rounded-lg outline-none transition-colors ${
              error
                ? 'border-red-400 bg-red-50'
                : 'border-gray-300 focus:ring-2 focus:ring-[#99DF63] focus:border-[#00594C]'
            }`}
          />
          <button
            type="submit"
            className="w-full bg-[#99DF63] text-[#00594C] py-3 rounded-full font-bold hover:bg-[#8BCF52] transition-all"
          >
            Enter
          </button>
        </form>
      </div>
    </div>
  );
};

export default PasswordGate;
